// Presence Icon
// - Properties:
//   - state: AVAILABLE/BUSY/OUT_OF_OFFICE/OFF_WORK/HOLIDAY
//   - size: Size of icon in pixels

<template>
	<div class="icon">
		<svg :class="iconStyle" style="border:1px solid #aaaaaae8;vertical-align:top" :width="size" :height="size" xmlns="http://www.w3.org/2000/svg" viewBox="-3 -3 38 38" v-html="content">
		</svg>
	</div>
</template>

<script setup lang="ts">
import { EmployeePresenceState } from '@/TcxApi/Employee'
import { computed } from 'vue'

interface Props {
	state: EmployeePresenceState
	size: number
}

const props = withDefaults(defineProps<Props>(), {
	state: EmployeePresenceState.AVAILABLE,
	size: 32
})

const content = computed(() => {
	switch (props.state) {
		case EmployeePresenceState.AVAILABLE:
			return '<path id="check" d="M27.37592,9.70459l-14.151,15.97693a.99985.99985,0,0,1-1.47558.02356L4.59711,18.1322a.99992.99992,0,0,1-.05384-1.31128L5.495,15.63123a.99994.99994,0,0,1,1.22808-.26966L12,18,24.79724,7.09863a.99991.99991,0,0,1,1.35553.0542l1.1817,1.18164A1,1,0,0,1,27.37592,9.70459Z"/>'
		case EmployeePresenceState.BUSY:
			return '<path id="minus" d="M26,14v4a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H25A1,1,0,0,1,26,14Z"/>'
		case EmployeePresenceState.OUT_OF_OFFICE:
			return '<path id="car" d="M27.16541,14.38342,25.67456,7.9231A3.96238,3.96238,0,0,0,22,5H10A3.96238,3.96238,0,0,0,6.32544,7.9231L4.83459,14.38342A1.99637,1.99637,0,0,0,4,16V27a1,1,0,0,0,1,1H7a1,1,0,0,0,1-1V24H24v3a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V16A1.99637,1.99637,0,0,0,27.16541,14.38342ZM8.27393,8.373A1.96715,1.96715,0,0,1,10,7H22a1.96715,1.96715,0,0,1,1.72607,1.373L24.79358,13H7.20642ZM10,17.5a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Zm16,0a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Z"/>' // eslint-disable-line
		case EmployeePresenceState.OFF_WORK:
			return '<path id="moon" d="M25.29614,20.86829a1.04839,1.04839,0,0,0-.15277.01129A11.28987,11.28987,0,0,1,23.5,21a11.44774,11.44774,0,0,1-2.25989-.22675,11.56691,11.56691,0,0,1-9.096-9.44781,11.44715,11.44715,0,0,1,.32422-5.05811,1.01029,1.01029,0,0,0-.9494-1.30255.98825.98825,0,0,0-.40515.0885A11.99168,11.99168,0,0,0,15.16528,27.9715c.28.019.55884.0285.83478.0285a11.985,11.985,0,0,0,10.1485-5.621A.99379.99379,0,0,0,25.29614,20.86829ZM16.00006,25c-.20856,0-.41925-.00714-.63092-.02155A8.98582,8.98582,0,0,1,9.02332,10.33319q.0422.72793.15734,1.45929A14.53714,14.53714,0,0,0,20.63574,23.71179,8.93408,8.93408,0,0,1,16.00006,25Z"/>' // eslint-disable-line
			// return '<path id="glass" d="M17,17v8l4.64368,1.39307a.5.5,0,0,1,.35632.479V27.5a.5.5,0,0,1-.5.5H9.5a.5.5,0,0,1-.5-.5v-.62793a.5.5,0,0,1,.35632-.479L14,25V17L4.61914,4.80493A.5.5,0,0,1,5.01544,4H25.98456a.5.5,0,0,1,.3963.80493Z"/>' // eslint-disable-line
		case EmployeePresenceState.HOLIDAY:
			return '<path id="beach-umbrella" d="M15,18h2v9a1,1,0,0,1-2,0Zm13-1a4.81241,4.81241,0,0,0-3-1,4.9816,4.9816,0,0,0-4.03375,2.06836,6.99623,6.99623,0,0,0-9.93244,0A4.98039,4.98039,0,0,0,4,17,11.99443,11.99443,0,0,1,15,5.05054V4a1,1,0,0,1,2,0V5.05054A11.99443,11.99443,0,0,1,28,17ZM15.32629,7.02783a10.02018,10.02018,0,0,0-8.87365,6.99365Q6.7251,14.00024,7,14a6.95441,6.95441,0,0,1,3.21143.79346A11.9987,11.9987,0,0,1,15.32629,7.02783ZM25,14q.27466,0,.54736.02148a10.02018,10.02018,0,0,0-8.87365-6.99365,11.9987,11.9987,0,0,1,5.11486,7.76563A6.95441,6.95441,0,0,1,25,14Z"/>' // eslint-disable-line
		default:
			return ''
	}
})

const iconStyle = computed(() => { return props.state.toLowerCase() })
</script>

<style scoped>
	.icon          { border-radius: 50%; }
	.available     { background-color: var(--presence-available); fill: var(--presence-color); border-radius: 50%; }
	.busy          { background-color: var(--presence-busy); fill: var(--presence-color); border-radius: 50%; }
	.out_of_office { background-color: var(--presence-out-of-office); fill: var(--presence-color); border-radius: 50%; }
	.off_work      { background-color: var(--presence-off-work); fill: var(--presence-color); border-radius: 50%; }
	.holiday       { background-color: var(--presence-holiday); fill: var(--presence-color); border-radius: 50%; }
</style>
